module.exports = __webpack_public_path__ + "img/folder_ico.e26dbcbe.png";